import useSlideOver from '../../../useSlideOver';
import UseContext from '../../../../../hooks/useContext';
import SlideOverHeader from '../../../component/header';
import SlideOverBody from '../../../component/body';
import AdminMissionDetails from '../../../../../pages/pages/mission/adminMissionDetails';
import { useState, useEffect } from 'react';
import { SkeletonLine } from '../../../../skeleton/Skeleton';

const SlideOverMission = () => {
  const { objID, missionInitialPage, setMissionInitialPage } = UseContext();
  const { toggleSlideOver } = useSlideOver();
  const [searchMissionResult, setSearchMissionResult] = useState([]);
  // The mission's title and creator, sent by the details once read.
  const [header, setHeader] = useState(null);
  useEffect(() => setHeader(null), [objID]);

  // Réinitialiser missionInitialPage après l'avoir utilisé
  useEffect(() => {
    if (missionInitialPage !== undefined) {
      setMissionInitialPage(undefined);
    }
  }, [objID]);

  const closeSlideOver = () => {
    toggleSlideOver('');
    setMissionInitialPage(undefined);
  };

  return (
    <>
      <SlideOverHeader hide={closeSlideOver} hideShow={true} description={header?.description}>
        {header ? header.title : <SkeletonLine className="h-6 w-64" />}
      </SlideOverHeader>
      <SlideOverBody>
        {objID ? (
          <AdminMissionDetails
            missionId={objID}
            searchMissionResult={searchMissionResult}
            setSearchMissionResult={setSearchMissionResult}
            initialPage={missionInitialPage}
            isSlideOver
            onHeader={setHeader}
          />
        ) : (
          <div className="p-4 text-gray-500">Aucune mission sélectionnée</div>
        )}
      </SlideOverBody>
    </>
  );
};

export default SlideOverMission;

